export { default } from './RowsPerPage.component';
